"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterComponent = RouterComponent;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const account_context_1 = require("@src/context/account-context");
const actions_1 = __importDefault(require("@src/actions"));
const offer_promotion_context_1 = require("@src/components/pages/admin/modules/offers/offer-promotion-context");
const Routes_1 = __importDefault(require("./Routes"));
function RouterComponent(props) {
    const { store, history } = props;
    const { value: OfferPromotionValue, OfferPromotionContextProvider } = (0, offer_promotion_context_1.useOfferPromotionContext)();
    react_1.default.useEffect(() => {
        store.dispatch(actions_1.default.mainInitStart());
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_router_1.Router, { history: history, children: (0, jsx_runtime_1.jsx)(account_context_1.AccountContextProvider, { children: (0, jsx_runtime_1.jsx)(OfferPromotionContextProvider, { value: OfferPromotionValue, children: (0, jsx_runtime_1.jsx)(Routes_1.default, {}) }) }) }));
}
